import { useState } from "react";
import { toast } from "react-toastify";
import {
  useGetCorporateOfferDetailsQuery,
  useLazyGetCorporateOfferCodesQuery,
} from "../../../../../store/queries/Subscription";

const useOfferDetails = (offerId) => {
  const [isExporting, setIsExporting] = useState(false);

  const { data: detailData = {}, isFetching } =
    useGetCorporateOfferDetailsQuery(
      { offer_id: offerId },
      { skip: !offerId }
    );

  const [fetchCodes] = useLazyGetCorporateOfferCodesQuery();

  const offer = detailData?.data ?? {};

  /**
   * The codes come back as JSON and become the CSV handed to the organisation here - there
   * is no file to download from the service. Shared-code offers have nothing to export and
   * are refused with corporate_offer_shared_code.
   */
  const handleExportCodes = async () => {
    setIsExporting(true);
    const response = await fetchCodes({ offer_id: offerId });

    if (response?.data?.status_code !== 200) {
      toast.error(
        response?.error?.data?.message ??
          response?.data?.message ??
          `Unable to export the codes`
      );
      setIsExporting(false);
      return;
    }

    const payload = response?.data?.data ?? {};
    const rows = [
      ["code", "status", "used_at", "user_id", "subscription_id"],
      ...(payload?.codes ?? []).map((item) => [
        item?.code ?? "",
        item?.status_label ?? "",
        item?.used_at ?? "",
        item?.user_id ?? "",
        item?.subscription_id ?? "",
      ]),
    ];

    const csv = rows
      .map((row) =>
        row
          .map((cell) => `"${String(cell).replace(/"/g, '""')}"`)
          .join(",")
      )
      .join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${payload?.offer_code ?? "corporate-offer"}-codes.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    setIsExporting(false);
  };

  return {
    offer,
    isFetching,
    isExporting,
    handleExportCodes,
  };
};

export default useOfferDetails;
